import FacetFilter from '@tkww/ads-content-component-fashion-facet-filter';
import React from 'react';

const FacetFilterWrapper = (props) => {
  return (
    <FacetFilter {...props} />
  );
}

export default FacetFilterWrapper;
